import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import ProgressiveProfilingContainer from "../containers/ProgressiveProfilingContainer";

const ProgressiveProfilingPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <ProgressiveProfilingContainer />
    </UnderMaintenanceOrChildren>
  );
};

export default ProgressiveProfilingPage;
